export default __webpack_public_path__ + "static/media/dashboard.cd39f2bf.png";